import { updateKerioMailboxPassword, } from "@apps/client-sdk";
import { el } from "../dom.js";
/** Detect Kerio API auth failures that usually mean an app password was stored. */
export function isKerioAuthError(message) {
    const lower = message.toLowerCase();
    return (lower.includes("password") ||
        lower.includes("not correct") ||
        lower.includes("login") ||
        lower.includes("unauthorized") ||
        lower.includes("401") ||
        lower.includes("app password"));
}
/**
 * Inline form to replace the stored Kerio primary password without re-pairing.
 */
export function renderKerioPasswordUpdate(storage, onSaved) {
    const wrap = el("div", "kerio-password-update card mt");
    wrap.append(el("p", "hint", "Kerio’s API rejects app passwords. Enter your normal account password "
        + "(not a 2FA code). Then try again."));
    const input = el("input", "input");
    input.type = "password";
    input.placeholder = "Account password";
    input.autocomplete = "off";
    const btn = el("button", "btn btn-primary btn-sm", "Save password");
    btn.type = "button";
    const status = el("p", "muted", "");
    btn.addEventListener("click", () => {
        void (async () => {
            try {
                await updateKerioMailboxPassword(storage, input.value);
                input.value = "";
                status.className = "success";
                status.textContent = "Password saved. Retrying…";
                onSaved();
            }
            catch (error) {
                status.className = "error";
                status.textContent =
                    error instanceof Error ? error.message : "Failed to save password";
            }
        })();
    });
    const row = el("div", "inline-add mt");
    row.append(input, btn);
    wrap.append(row, status);
    return wrap;
}
